<template>
  <footer id="footer">
    <div class="container">
      <share-buttons></share-buttons>
      <nav class="footer-nav">
        <ul>
          <li>
            <router-link class="hide-decoration" :to="{ name: 'consulting' }">Consulting</router-link>
          </li>
          <li>
            <a class="hide-decoration" href="https://decisiondeskhq.com/privacy-policy/">Privacy Policy</a>
          </li>
          <!-- <li :key="$auth.authenticated" v-if="!$auth.authenticated">
            <router-link :to="{ name: 'login' }">Login</router-link>
          </li>
          <li :key="$auth.authenticated" v-else>
            <a href="/" @click="logout">Logout</a>
          </li> -->
        </ul>
      </nav>
      <div class="copyright">&copy; {{ new Date().getFullYear() }} Øptimus Consulting, LLC. and Decision Desk HQ. All rights reserved</div>
      <div class="copyright">Forecast developed by 0ptimus Analytics</div>
    </div>
  </footer>
</template>

<script>
import ShareButtons from '@/components/common/ShareButtons'

const name = 'fc_footer'

const components = {
  ShareButtons
}

const methods = {
  logout () {
    this.$auth.logout()
    if ((this.$route.meta || {}).auth === true) {
      this.$router.push('/')
    }
  }
}

export default {
  name,
  components,
  methods
}
</script>

<style>
#footer {
  padding: 2rem 0 2rem;
  z-index: 550;
  border-top: 1px solid rgba(0, 0, 0, 0.12);
}

#footer .container {
  flex-direction: column;
  align-items: center;
}

#footer .footer-nav {
  border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;
  margin-bottom: 16px;
  padding: 14px 0;
}

#footer .footer-nav ul {
  display: flex;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  padding: 0;
}

#footer .footer-nav a {
  margin: 0 10px;
  color: #a2a2a2 !important;
}

#footer .copyright {
  font-size: 14px;
  text-transform: uppercase;
  color: #a2a2a2;
  text-align: center;
}

@media only screen and (max-width: 960px) {
  #footer {
    padding-bottom: 80px;
  }
}
</style>
